import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ChartDataService {

  normalizeDataToStartAt100(
    data: { date: string; value: number; isBenchmark?: boolean }[]
  ): { date: string; value: number; isBenchmark?: boolean }[] {
    const initialValue = data[0]?.value || 1;
    return data.map(entry => ({
      date: entry.date,
      value: (entry.value / initialValue) * 100,
      isBenchmark: entry.isBenchmark // Behalte das isBenchmark-Flag bei
    }));
  }


  processChartData(chartDataInput: any, productData: any): any[] {
    // Sortiere und normalisiere die Produktdaten
    const productDataSorted = chartDataInput.product_data.sort(
      (a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime()
    );
    const normalizedProductData = this.normalizeDataToStartAt100(productDataSorted);

    // Produktdaten mit isBenchmark: false
    const chartData = [{
      data: normalizedProductData,
      name: productData.translations['en'].title,
      isBenchmark: false
    }];

    // Benchmark-Daten mit isBenchmark: true
    if (chartDataInput.benchmark_data) {
      chartDataInput.benchmark_data.forEach((benchmark: any) => {
        const sortedBenchmark = benchmark.data.sort(
          (a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime()
        );
        const normalizedBenchmark = this.normalizeDataToStartAt100(sortedBenchmark);

        chartData.push({
          data: normalizedBenchmark,
          name: benchmark.name,
          isBenchmark: true // Hier wird das Flag hinzugefügt
        });
      });
    }

    return chartData;
  }

}
